import { BadgeWidget, Tooltip } from '@tableau/widgets';
import React from 'react';

import { Messages } from '../../codegen/Localize';
import { ExplorableItemType } from '../../spacesPlatform/models/ContentType';
import { DraftStyles } from '../styles/DraftStyles';
import { DraftTagType } from '../types/DraftsTypes';

export interface DraftTagProps {
  readonly draftTag: string;
  readonly tagType: DraftTagType;
  readonly explorableItemType: ExplorableItemType;
}

export class DraftTag extends React.Component<DraftTagProps>{
  public render() {
    const badge =
      <BadgeWidget
        className={DraftStyles.DraftTagStyle}
        kind={this.props.draftTag === Messages.draftTag() ? 'primary' : 'secondary'}
        data-tb-test-id={`${this.props.tagType}-tag`}
      >
        {this.props.draftTag}
      </BadgeWidget>;
    const tooltipContent = this.getTooltipContent();

    if (tooltipContent) {
      return <Tooltip tooltipContent={tooltipContent} maxWidth={200} children={badge} />;
    } else {
      return badge;
    }
  }

  private getContentTypeString(contentType: string) {
    if (contentType === 'virtualConnection') {
      return Messages.virtualConnectionLowerCase();
    }
    return contentType;
  }

  private getTooltipContent = () => {
    const CONTENT_TYPE = this.getContentTypeString(this.props.explorableItemType as string);

    let content: string;
    switch (this.props.tagType) {
      case DraftTagType.neverPublished:  //never published
        content = Messages.draftUnpublishedTagTooltip({ CONTENT_TYPE });
        break;
      case DraftTagType.unpublished:  // changes to existing workbook
        content = Messages.draftTagTooltip({ CONTENT_TYPE });
        break;
      case DraftTagType.staticTag: //fall through
      default:
        return null;
    }
    return (
      <div data-tb-test-id={`${this.props.tagType}-drafttag-tooltip`}>
        {content}
      </div>
    );
  };
}
